import {
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const authRefreshInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);

    // Signing in never needs a refresh first, and attempting one with a stale token
    // would 401 and tear down the sign-in page before the request is even sent.
    const isAuthEntryPoint =
        req.url.includes('/api/users/refresh') ||
        req.url.includes('api/users/login') ||
        req.url.includes('api/users/request-otp') ||
        req.url.includes('api/users/verify-otp');

    if (
        !isAuthEntryPoint &&
        authService.accessToken &&
        AuthUtils.isTokenExpired(authService.accessToken)
    ) {
        return authService.refreshAccessToken().pipe(
            switchMap((_) => {
                return next(req);
            })
        );
    }

    return next(req);
};
